/* @minVersion 7.22.6 */

// eslint-disable-next-line no-unused-vars
export default function _nullishReceiverError(r) {
  throw new TypeError("Cannot set property of null or undefined.");
}
